import React, { useEffect, useRef, useState } from 'react';
import * as d3 from 'd3';
import { Box } from '@mui/material';

const AgeLine = ({ chronologicalAge, dataPoint }) => {
  const svgRef = useRef();
  const containerRef = useRef();
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      if (!entries || entries.length === 0) return;
      const newWidth = entries[0].contentRect.width;
      setWidth(newWidth);
    });

    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }

    return () => resizeObserver.disconnect();
  }, []);

  useEffect(() => {
    if (width === 0) return;

    const height = 80;
    const margin = { top: 2, bottom: 2, left: 2, right: 2 };

    const svg = d3.select(svgRef.current);
    svg.selectAll('*').remove();

    const ageExtent = [0, 100];
    const xScale = d3.scaleLinear()
      .domain(ageExtent)
      .range([margin.left, width - margin.right]);

    // Horizontal line
    svg.append('line')
      .attr('x1', xScale(ageExtent[0]))
      .attr('x2', xScale(ageExtent[1]))
      .attr('y1', height / 2)
      .attr('y2', height / 2)
      .attr('stroke', '#ccc')
      .attr('stroke-width', 2);

    // Chronological age marker
    svg.append('line')
      .attr('x1', xScale(chronologicalAge))
      .attr('x2', xScale(chronologicalAge))
      .attr('y1', height / 2 - 10)
      .attr('y2', height / 2 + 10)
      .attr('stroke', '#fff')
      .attr('stroke-width', 4);

{/*
    svg.append('text')
      .attr('x', xScale(chronologicalAge))
      .attr('y', height / 2 + 25)
      .attr('text-anchor', 'middle')
      .attr('fill', '#000')
      .style('font-size', '12px')
      .text('Chronological Age');
*/}

    const bubbleColor = dataPoint.age < chronologicalAge ? 'green' : 'red';

    // Bubble
    svg.append('circle')
      .attr('cx', xScale(dataPoint.age))
      .attr('cy', height / 2)
      .attr('r', 8)
      .attr('fill', bubbleColor)
      .attr('stroke', '#fff')
      .attr('stroke-width', 1);

    // Label
    svg.append('text')
      .attr('x', xScale(dataPoint.age))
      .attr('y', height / 2 - 24)
      .attr('text-anchor', 'middle')
      .attr('fill', '#fff')
      .style('font-size', '14px')
      .text(`${dataPoint.disease}: ${dataPoint.age}`);

  }, [chronologicalAge, dataPoint, width]);

  return (
    <Box ref={containerRef} >
      <svg ref={svgRef} height={75} width="100%" />
    </Box>
  );
};

export default AgeLine;
